import { render, staticRenderFns } from "./WidgetKpi.vue?vue&type=template&id=094dff84&scoped=true&"
import script from "./WidgetKpi.vue?vue&type=script&lang=js&"
export * from "./WidgetKpi.vue?vue&type=script&lang=js&"
import style0 from "./WidgetKpi.vue?vue&type=style&index=0&id=094dff84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094dff84",
  null
  
)

export default component.exports